import { useMemo, useCallback, useState } from 'react'
import { Dropdown } from '../dropdown'
import { Owner } from '../../models/polymer/Owner.model'
import { Occupier } from '../../models/polymer/Occupier.model';
import { DropdownItemInterface } from '../../models/interfaces/dropdown-item.interface';
import { P2TextLabel } from "react-bootstrap-common-script";
import { HouseholdFormData } from '../../models/classes/ApplicationStep1.class';
import { MyInfoWithDOD } from '../../models/polymer/MyInfo.model';

interface OwnerOccupierSelectionProps{
  label?:string,
  required?:boolean,
  variant?: "owner" | "occupier";
  placeholder?: string,
  householdFormData?: HouseholdFormData;
  additionalRoles?: MyInfoWithDOD[];
  holding?:Owner[] | Occupier[];
  selection_holding_number?: number;
  onSelection?:(value:string)=>void;
  onAddNewClick?:()=>void;
  onNotApplicableClick?:()=>void;
  limit?:number;
  disabled?: boolean;

}

const checkIsIncluded = (list: any[] | undefined, item: any) => {
    if(list !== undefined){
      return list.some(e => e.myinfo?.uinfin === item.myinfo?.uinfin || e.myinfo?.name === item.myinfo?.name);
    }else{
      return false;
    }
}

const checkIsIncludedForAdditionalRole = (list: Owner[] | Occupier[] = [], item: MyInfoWithDOD) => {
  return list.some(e => e.myinfo?.uinfin === item?.uinfin || e.myinfo?.name === item?.name);
}

function OwnerOccupierSelection({disabled=false, limit=4, required=false, variant="owner", holding=[], selection_holding_number=0, additionalRoles = [], ...props}:OwnerOccupierSelectionProps) {
  
  const [isNotApplicable, setIsNotApplicable] = useState<boolean>(false);

  const checkIsExceedAdd = () =>{
    if(selection_holding_number >= limit){
      return true;
    }  
    return false;
  }

  const ProcessDropdownItems:DropdownItemInterface[] = useMemo(():DropdownItemInterface[]=>{
    let dropdownList : DropdownItemInterface[] = [];
    props.householdFormData?.owners?.forEach((item,_index)=>{
      
      let isExisted = checkIsIncluded(props.householdFormData?.incoming_owners, item);

      let isHolding = holding.some(e=>{
        return (e.myinfo?.uinfin || e.myinfo?.name) && (e.myinfo?.uinfin === item.myinfo?.uinfin || e.myinfo?.name === item.myinfo?.name);
      })
      
      if(!isExisted && !isHolding){
        let obj:DropdownItemInterface = {
          id:_index,
          title: item.myinfo.name,
          value: item?.myinfo?.uinfin
        }
        dropdownList.push(obj);
      }
    });
    
    props.householdFormData?.occupiers?.forEach((item,_index)=>{
      let isCurrentOwner = checkIsIncluded(props.householdFormData?.owners, item);
      let isExisted = checkIsIncluded(props.householdFormData?.incoming_occupiers, item);
      
      let isHolding = holding.some(e=>{
        return (e.myinfo?.uinfin || e.myinfo?.name) && (e.myinfo?.uinfin === item.myinfo?.uinfin || e.myinfo?.name === item.myinfo?.name);
      })
      
      if(!isExisted && !isHolding && !isCurrentOwner){
        let obj:DropdownItemInterface = {
          id:_index,
          title: item.myinfo.name,
          value: item?.myinfo?.uinfin
        }
        dropdownList.push(obj);
      }
    });

    additionalRoles.forEach((item,_index)=>{
      let isCurrentOwner = checkIsIncludedForAdditionalRole(props.householdFormData?.owners, item);
      let isCurrentOccupier = checkIsIncludedForAdditionalRole(props.householdFormData?.occupiers, item);
      let isExisted = checkIsIncludedForAdditionalRole(props.householdFormData?.incoming_owners, item) || checkIsIncludedForAdditionalRole(props.householdFormData?.incoming_occupiers, item);
  
      let isHolding = holding.some(e=>{
        return (e.myinfo?.uinfin || e.myinfo?.name) && (e.myinfo?.uinfin === item.uinfin || e.myinfo?.name === item.name);
      })
      
      if(!isExisted && !isHolding && !isCurrentOwner && !isCurrentOccupier){
        let obj:DropdownItemInterface = {
          id:_index,
          title: item.name,
          value: item?.uinfin
        }
        dropdownList.push(obj);
      }
    });
    
    return dropdownList;
  },[ holding, props.householdFormData?.incoming_occupiers, props.householdFormData?.incoming_owners, props.householdFormData?.occupiers, props.householdFormData?.owners, additionalRoles])

  const addNewTitle = variant === "owner" ? "New owner" : "New occupier";

  const handleSelection = useCallback((value: any) => {
      if (value === "Not applicable") {
        setIsNotApplicable(true);
      } else {
        setIsNotApplicable(false);
      }
      props?.onSelection?.(value);
  }, [props]);
  
  return (
    <div>
      {props.label
        ? (
            <P2TextLabel
              fontSize='1.125rem'
              color='#000'
              label={props.label}
              bold={700}
              hasTooltip={props.label.includes("occupiers") ? true : false}
              tooltipContent={props.label.includes("occupiers") ? "Occupiers are people who are staying in the flat. They do not  have an interest in the ownership of the flat and may affect the eligibility to retain the flat under an eligibility scheme. Adding of occupiers is not mandatory. " : "" }
              required={props.label.includes("occupiers") ? false : true}
            />
          )
        : <></>
      }
      <Dropdown allowAddNew allPlusIcon disabled={checkIsExceedAdd() || disabled} style={{ marginTop: 8 }} variant={"small"} selectedDropdown={isNotApplicable ? "Not applicable" : ""} setSelectedDropdown={handleSelection} onNotApplicableClick={props.onNotApplicableClick} onAddNewClick={props.onAddNewClick} items={ ProcessDropdownItems } placeholder={props.placeholder} addNewTitle={addNewTitle} notApplicable={variant === 'occupier' ? true : false}/>
    </div>
  )
}

export default OwnerOccupierSelection